/**
 * « Esprit sylvestre », the forest's shop pack (ADR 0031): a dryad's garb of
 * bark, moss and blossom, fireflies drifting round the crown, a flowering
 * branch for a blade, a shield of woven roots, and a white stag in bloom.
 * Looks only, over the real gear; apart on purpose from the forest's loot
 * set (`hunter-*`) and the tutorial's bark set (`bark-*`).
 */
const PACK = 'sylvan';
const piece = (id, name, slot, classes) => ({
    id,
    lootable: false,
    cosmetic: true,
    name,
    kind: 'equipment',
    slot,
    rarity: 'epic',
    ...(classes === undefined ? {} : { classes }),
    sprite: `overlay.${id}`,
    icon: `icon.${id}`,
});
const single = (id, name, blurb, priceCents) => ({
    id,
    name,
    blurb,
    pack: PACK,
    items: [{ templateId: id }],
    priceCents,
});
export const SYLVAN_FILE = {
    templates: [
        piece('sylvan-blade', 'Lame sylvestre', 'weapon'),
        piece('sylvan-crown', 'Couronne sylvestre', 'helmet'),
        piece('sylvan-chest', 'Cuirasse sylvestre', 'chest'),
        piece('sylvan-gloves', 'Gantelets sylvestres', 'gloves'),
        piece('sylvan-boots', 'Bottes sylvestres', 'boots'),
        piece('sylvan-shield', 'Bouclier de racines', 'offhand', ['warrior']),
        {
            id: 'sylvan-stag',
            lootable: false,
            name: 'Cerf sylvestre',
            kind: 'equipment',
            slot: 'mount',
            rarity: 'epic',
            companion: 'sylvan-stag',
            icon: 'icon.sylvan-stag',
        },
    ],
    offers: [
        single('sylvan-blade', 'Lame sylvestre', 'Une branche vivante taillée en épée, fleurie de la garde à la pointe, portée par-dessus ton arme. Animée.', 399),
        single('sylvan-crown', 'Couronne sylvestre', 'Des bois de cerf en fleurs noués de lierre, et des lucioles qui tournent autour. Animée.', 299),
        single('sylvan-chest', 'Cuirasse sylvestre', 'Écorce et mousse tissées de fleurs, où court une liane vivante.', 399),
        single('sylvan-gloves', 'Gantelets sylvestres', 'Des mains d’écorce enlacées de lierre en fleurs.', 199),
        single('sylvan-boots', 'Bottes sylvestres', 'Des bottes de racines et de mousse, comme poussées du sol.', 199),
        single('sylvan-shield', 'Bouclier de racines', 'Des racines tressées en écu autour d’un cœur de mousse lumineuse. Animé.', 299),
        single('sylvan-stag', 'Cerf sylvestre', 'Un cerf blanc paré de mousse et de fleurs, qui te porte deux fois plus vite que tes jambes.', 599),
        {
            id: 'sylvan-pack',
            name: 'Esprit sylvestre',
            blurb: 'Toute la parure de la dryade (couronne, cuirasse, gantelets, bottes, lame et bouclier) et le cerf blanc paré de fleurs, par-dessus ton équipement.',
            pack: PACK,
            items: [
                { templateId: 'sylvan-blade' },
                { templateId: 'sylvan-crown' },
                { templateId: 'sylvan-chest' },
                { templateId: 'sylvan-gloves' },
                { templateId: 'sylvan-boots' },
                { templateId: 'sylvan-shield' },
                { templateId: 'sylvan-stag' },
            ],
            priceCents: 999,
            worthCents: 2493,
        },
    ],
};
//# sourceMappingURL=sylvan.js.map